import React, { memo, ReactNode, useEffect } from 'react';
import { Routes as RRoutes, useLocation, useNavigate } from 'react-router-dom';
import { NavigationRoutes } from '../../navigation/type';
import { useSelector } from 'react-redux';
import { AuthState } from '../../store/reducer/auth';
import useSWR from 'swr';
import { UserApi } from '../../apis';

type Props = {
  children: ReactNode;
};

const PUBLIC_ROUTES = [
  NavigationRoutes.Login_Screen,
  NavigationRoutes.Forgot_Screen,
  NavigationRoutes.Otp_Screen,
  NavigationRoutes.Password_Screen,
];

const Routes = memo(({ children }: Props) => {
  const { accessToken } = useSelector((state: { auth: AuthState }) => state?.auth);
  const { data, isLoading, error } = useSWR(accessToken ? '/api/user/me' : '', UserApi.me);
  // ^ accessToken байхгүй бол /me дуудлага хийхгүй

  console.log('error =>', error);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoading) return;

    const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);
    const isLoginPage = location.pathname === NavigationRoutes.Login_Screen;

    if (!accessToken) {
      console.log('location.pathname :', location.pathname);
      if (isPublicRoute) return;

      window.location.href = '/login';
      // navigate(NavigationRoutes.Login_Screen, { replace: true });
      return;
    }

    if (accessToken && !data) {
      if (!isLoginPage) {
        navigate(NavigationRoutes.Login_Screen, { replace: true });
      }
      return;
    }

    if (accessToken && data && isLoginPage) {
      navigate(NavigationRoutes.Home_Screen, { replace: true });
    }
  }, [accessToken, data, isLoading, location.pathname, navigate]);

  return <RRoutes>{children}</RRoutes>;
});

Routes.displayName = 'Routes';

export { Routes };
